import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { FAQ_CONTENT, HOW_TO_DETERMINE_TCO, TCO_EXPLANATION } from 'site-modules/editorial/constants/tco-content';
import { getBaseBreadcrumb, getHomeBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';
import { getTCOUrl } from 'site-modules/shared/utils/core-link-constructor';
import { WRAPPER_TYPES } from 'site-modules/shared/components/faq/constants';
import { Faq } from 'site-modules/shared/components/faq/faq';
import { AdUnit } from 'site-modules/shared/components/ad-unit/ad-unit';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { ContentBlock } from 'site-modules/editorial/components/content-block/content-block';
import { VehicleSelector } from 'site-modules/editorial/components/vehicle-selector/vehicle-selector';
import { PageLinksWidget } from 'site-modules/shared/components/page-links-widget/page-links-widget';

import './tco.scss';

export const BREADCRUMBS = [getHomeBreadcrumb(), getBaseBreadcrumb('Cost of car ownership')];

export function generateTcoUrl({ style }) {
  if (!style) {
    return null;
  }

  const { id, makeSlug, modelSlug, year } = style;
  return getTCOUrl({ makeSlug, modelSlug, year }, id);
}

export function Tco({ location = null }) {
  return (
    <Container tag="main" id="main-content" tabIndex={-1} className="tco-page">
      <Row>
        <Col xs={12} lg={8}>
          <Breadcrumbs data={BREADCRUMBS} className="ps-0 mb-1_5" />
          <h1 className="heading-2 mb-1_5">Cost of Car Ownership</h1>
          <h2 className="heading-3 mb-1_5">Calculate the Cost of Owning a Car</h2>
          <p className="size-16 mb-0_5">
            The Edmunds Inc. True Cost to Own<sup>&reg;</sup> (TCO<sup>&reg;</sup>) pricing system calculates the
            additional costs you may not have included when considering your next vehicle purchase. These extra costs
            include: depreciation, interest on your loan, taxes and fees, insurance premiums, fuel costs, maintenance,
            and repairs. Search here to view the TCO<sup>&reg;</sup> of any vehicle.
          </p>
          <Row className="mt-1">
            <Col xs={12} lg={10}>
              <VehicleSelector generateBtnLink={generateTcoUrl} showLatestYears />
            </Col>
          </Row>
          <hr className="mt-1_5 mb-2" />
          <section>
            <h2 className="heading-3 mb-1_5">Car Depreciation Calculator</h2>
            <ContentBlock
              items={TCO_EXPLANATION}
              className=""
              titleClassName="heading-3"
              sectionTitleClassName="heading-4"
              sectionSubtitleClassName="heading-5 mb-1"
              paragraphTitleClassName="fw-bold mb-0_5"
              itemsBeforeCollapseNum={4}
            />
            <hr className="mt-1_5 mb-2" />
            <ContentBlock
              items={HOW_TO_DETERMINE_TCO}
              className=""
              titleClassName="heading-3"
              sectionTitleClassName="heading-4"
              sectionSubtitleClassName="heading-5 mb-1"
              paragraphTitleClassName="fw-bold mb-0_5"
              itemsBeforeCollapseNum={4}
            />
          </section>
          <hr className="mt-1_5 mb-2" />
          <Faq
            entries={FAQ_CONTENT}
            title="True Cost to Own FAQs"
            wrapperType={WRAPPER_TYPES.accordion}
            pathname={get(location, 'pathname')}
            generateLearnMoreLinks
          />
        </Col>
        <Col xs={12} lg={4}>
          <AdUnit adName="mrect" position={'1'} noRefresh lg xl />
        </Col>
      </Row>
      <hr className="mt-1_5 mb-2" />
      <PageLinksWidget divideSections={false} title="Related information" />
    </Container>
  );
}

Tco.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};
